import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import useHtmlMeta from '~/composables/useHtmlMeta';
import Toaster from '~/components/Layout/Toaster.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'error',
  props: {
    error: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n;
    var _useHtmlMeta = useHtmlMeta(),
      setHtmlLocale = _useHtmlMeta.setHtmlLocale;
    setHtmlLocale();
    useHead({
      title: props.error.statusCode === '404' ? i18n.t('errorPage.pageNotFoundHeaderTitle') : i18n.t('errorPage.anErrorOccurredTitle')
    });
    return {
      __sfc: true,
      props: props,
      i18n: i18n,
      setHtmlLocale: setHtmlLocale,
      AzButton: AzButton,
      Toaster: Toaster
    };
  }
});